import angular from 'angular';
import checkboxListComponent from './checkboxListComponent';

angular.module('sh.checkboxList', []).component('shCheckboxList', checkboxListComponent());
